import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setFieldId: YJSChangeHandler<DatabaseChangeType.SET_FIELD_ID> = ({
  ydb,
  change,
}) => {
  ydb.mutate((db) => {
    db.fieldsById[change.fieldId].fieldId = change.settingsFieldId;
  });
};
